var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { apiClient } from '../interceptor/interceptor';
/**
 * Fetch list of sleep study reports for a patient with order metadata.
 *
 * @param providerId - The provider ID (e.g., 'virtuox')
 * @param patientId - The patient ID
 * @returns Report list response with metadata (referrerName, requestType, orderedAt) and reports array
 * @throws ApiError if request fails (handled by interceptor)
 */
export const getReportList = (providerId, patientId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield apiClient.get(`/screener/providers/${providerId}/service-requests/patients/${patientId}/reports`);
    return response.data;
});
/**
 * Mark a specific report as viewed by the current practitioner.
 *
 * @param providerId - The provider ID (e.g., 'virtuox')
 * @param patientId - The patient ID
 * @param reportId - The report ID to mark as viewed
 * @throws ApiError if request fails (handled by interceptor)
 */
export const markIndividualReportAsViewed = (providerId, patientId, reportId) => __awaiter(void 0, void 0, void 0, function* () {
    yield apiClient.post(`/screener/providers/${providerId}/service-requests/patients/${patientId}/reports/${reportId}/viewed`);
});
/**
 * Fetch content of a specific sleep study report.
 *
 * @param providerId - The provider ID (e.g., 'virtuox')
 * @param reportId - The report ID
 * @returns Report content with metadata
 * @throws ApiError if request fails (handled by interceptor)
 */
export const getReportContent = (providerId, reportId) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const response = yield apiClient.get(`/screener/providers/${providerId}/reports/${reportId}/content`, {
        responseType: 'arraybuffer'
    });
    // Normalise the content-type by stripping charset/boundary params so that
    const rawContentType = ((_a = response.headers) === null || _a === void 0 ? void 0 : _a['content-type']) || 'application/pdf';
    const contentType = rawContentType.split(';')[0].trim().toLowerCase();
    const pdfData = response.data;
    return {
        reportId,
        reportType: 'pdf',
        reportName: `Report ${reportId}`,
        studyDate: '',
        testType: '',
        content: pdfData, // Will be ArrayBuffer
        contentType
    };
});
